import React from "react";
import {useTranslation} from "react-i18next";
import Box from "@awsui/components-react/box";
import Rider from "model/Rider";
import {formatNumber} from "common/formatNumber";
import {MAX_BUDGET} from "common/const";


interface LineupsValueProps {
    selectedRiders: Rider[];
}

const LineupsValue: React.FC<LineupsValueProps> = (props) => {

    const {t} = useTranslation("lineup");
    const ridersValue: number = props.selectedRiders.length
        ? props.selectedRiders
            .map((item: { value: number; }) => item.value)
            .reduce((previousValue: number, currentValue: number) => previousValue + currentValue)
        : 0;
    const moneyLeft: number = formatNumber(150 - ridersValue, 1);

    return (
        <Box
            textAlign={"left"}
            variant="span"
            fontSize="heading-xs"
            color={ridersValue > MAX_BUDGET ? "text-status-error" : "text-body-secondary"}
            fontWeight="bold"
        >
            {t("budget", {
                used: formatNumber(ridersValue, 1),
                remaining: Math.abs(moneyLeft),
                verb: moneyLeft > 0 ? t("budgetVerbLeft") : t("budgetVerbOver")
            })}
        </Box>
    );
};

export default LineupsValue;
